<template>
  <v-container>
    <module-bar
      :title="`ADMINISTRAR VEHICULO  (${
        type == 'vehicule_public' ? 'CARROS / CAMIONETAS' : 'MOTOS'
      })`"
      :icon="type == 'vehicule_public' ? 'mdi-car-search' : 'mdi-motorbike'"
    />
    <v-row>
      <v-col cols="12" v-if="schema != 'dash'">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  label="Placa / Chofer / Nombre"
                  v-model="parameter"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="default" @click="clearSearch">limpiar</v-btn>
            <v-btn text color="primary" @click="search">buscar</v-btn>
          </v-card-actions>
        </v-card>
        <v-row class="mt-10 mb-10" v-if="loadingSearch">
          <v-col cols="12" class="d-flex justify-center">
            <v-progress-circular
              indeterminate
              color="primary"
              width="2"
              size="65"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        class="d-flex justify-center mt-10"
        v-if="!vehicules && schema == 'dash'"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="60"
          width="2"
        />
      </v-col>

      <v-col cols="12" v-if="vehicules">
        <div>
          ({{ vehicules.length }})
          {{
            vehicules.length == 1
              ? ` vehiculo encontrado`
              : ` vehiculos encontrados`
          }}
        </div>
        <v-list>
          <v-list-item-group color="primary">
            <template v-for="(vehicule, key) in vehicules">
              <v-list-item
                :key="key"
                v-if="vehicules"
                @click="openDialogVehicule(key)"
              >
                <v-list-item-avatar size="80">
                  <v-img
                    :src="vehicule.photo_1"
                    :lazy-src="vehicule.photo_1_thumb"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ vehicule.name }} - {{ vehicule.plate }}</b>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    CHOFER : {{ vehicule.driver }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    MODELO: {{ vehicule.model }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon :color="vehicule.employee_id > 0 ? 'red' : 'green'">
                      mdi-circle</v-icon
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                :key="`div${key}`"
                v-if="key != vehicules.length - 1"
              />
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogVehicule" width="800" persistent>
      <v-card>
        <v-card-text>
          <vehicule-form
            title="EDITAR VEHICULO"
            schema="edit"
            :vehicule="vehicule"
            :click="click"
            @closeDialogVehicule="closeDialogVehicule"
            @deleteVehicule="deleteVehicule"
            @desvinculeEmployee="desvinculeEmployee"
            @vinculeEmployee="vinculeEmployee"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import VehiculeForm from "../../components/Forms/VehiculeForm.vue";

export default {
  components: { ModuleBar, VehiculeForm },

  props: ["schema", "type", "click_dash"],

  mounted() {
    if (this.schema == "dash") this.searchFromDash();
  },

  data() {
    return {
      click: 0,
      vehicule: null,
      dialogVehicule: false,
      vehicules: null,
      parameter: "",
      loadingSearch: false,
    };
  },

  watch: {
    parameter(value) {
      if (value) {
        this.parameter = value.toUpperCase();
      }
    },

    click_dash() {
      this.searchFromDash();
    },
  },

  computed: {},

  methods: {
    search() {
      if (this.parameter || this.zoneId || this.responsibleId) {
        this.vehicules = null;
        this.loadingSearch = true;
        setTimeout(() => {
          let payload = {
            parameter: this.parameter,
          };

          this.$store
            .dispatch("searchVehiculesAction", payload)
            .then((res) => {
              this.vehicules = res;

              this.loadingSearch = false;
            })
            .catch(() => {
              this.loadingSearch = false;
            });
        }, 500);
      }
    },

    clearSearch() {
      this.loadingSearch = false;
      this.parameter = "";
      this.vehicules = null;
    },

    openDialogVehicule(key) {
      this.click++;
      this.vehicule = this.vehicules[key];
      this.dialogVehicule = true;
    },

    closeDialogVehicule(data) {
      if (data) {
        let index = this.vehicules.findIndex((v) => v.id == data.id);
        this.vehicules.splice(index, 1, data);
      }
      this.dialogVehicule = false;
    },

    deleteVehicule(vehiculeId) {
      this.dialogVehicule = false;
      let index = this.vehicules.findIndex((v) => v.id == vehiculeId);
      this.vehicules.splice(index, 1);
    },

    searchFromDash() {
      this.vehicules = null;
      setTimeout(() => {
        this.$store
          .dispatch("searchByParameterDashAction", {
            parameter: this.type,
          })
          .then((res) => {
            this.vehicules = res;
          });
      }, 500);
    },

    desvinculeEmployee({ vehiculeId }) {
      let index = this.vehicules.findIndex((v) => v.id == vehiculeId);
      if (index > -1) {
        this.vehicules[index].employee_id = 0;
      }
    },

    vinculeEmployee(data) {
      let index = this.vehicules.findIndex(
        (v) => v.id == parseInt(data.vehicule_id)
      );

      if (index > -1) {
        this.vehicules[index].employee = data.employee;
        this.vehicules[index].employee_id = data.employee.id;
      }
    },
  },
};
</script>

<style></style>
